module.exports = __webpack_public_path__ + "static/media/galerija_2017 (13).7db184d0.jpg";